import angular from 'angular';
import FlowsTodoBridge from './FlowsTodoBridge';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
///
/// This state displays flows waiting on the user.
///
angular
  .module('flowingly.runner.flows.todo', [])
  .component('flowsTodo', FlowsTodoBridge)
  .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.flowstodo, {
    url: 'flowstodo',
    params: { title: 'To Do', backFromState: '' },
    controller: [
      '$stateParams',
      function ($stateParams) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const $ctrl = this;
        $ctrl.backFromState = $stateParams.backFromState;
      }
    ],
    controllerAs: '$ctrl',
    template: '<flows-todo back-from-state="$ctrl.backFromState"></flows-todo>'
  });
}
